const isRouteVisibleInDropdown = (obj, key) => {
    if (!obj) {
        return false;
    }

    for (const property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (property === key) {
                return obj[key]?.show || false;
            }
            // in case it's not the key and it is an object
            if (typeof obj[property] === 'object') {
                if (isRouteVisibleInDropdown(obj[property], key)) {
                    return true;
                }
            }
        }
    }
    return false;
};

exports.isContactUsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.CONTACT_US?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'CONTACT_US'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.CONTACT_US?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.CONTACT_US?.show;

exports.isProjectsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.PROJECTS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'PROJECTS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.PROJECTS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.PROJECTS?.show;

exports.isBlogsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.BLOGS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'BLOGS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.BLOGS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.BLOGS?.show;

exports.isDealsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.DEALS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'DEALS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.DEALS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.DEALS?.show;

exports.isEventsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.EVENTS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'EVENTS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.EVENTS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.EVENTS?.show;

exports.isTermsAndConditionsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.TERMS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'TERMS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.TERMS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.TERMS?.show;

exports.isMyProfileVisible =
    window.reloy_env.client_config.MY_PROFILE?.SHOW_MY_PROPERTY;

exports.isReferralVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.REFERRAL?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'REFERRAL'
    ) ||
    window.reloy_env.client_config.NAVIGATION_FOOTER?.REFERRAL?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.REFERRAL?.show;

exports.isRewardsVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.REWARDS?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'REWARDS'
    ) ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.REWARDS?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.REWARDS?.show;

exports.isRewardsVisibleOnNavbar =
    (window.reloy_env.client_config.NAVIGATION_ROUTES?.REWARDS?.show &&
        window.reloy_env.client_config.NAVIGATION_ROUTES?.REWARDS?.name?.trim() !==
            '') ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'REWARDS'
    ) ||
    (window.reloy_env.client_config.NAVIGATION_WEBVIEW?.REWARDS?.show &&
        window.reloy_env.client_config.NAVIGATION_WEBVIEW?.REWARDS?.name?.trim() !==
            '');
exports.isRentalVisible =
    window.reloy_env.client_config.NAVIGATION_ROUTES?.RENTAL?.show ||
    isRouteVisibleInDropdown(
        window.reloy_env.client_config.NAVIGATION_DROPDOWN,
        'RENTAL'
    ) ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.RENTAL?.show ||
    window.reloy_env.client_config.NAVIGATION_WEBVIEW?.RENTAL?.show;
